import ActionTypes from '../constants/action-types';

import { RootActionTypes, ThunkResult } from '../../../stores/types';
import formatErrorResponseV2, { FormattedErrorMessages } from '../../../utilities/format-error-response-v2';

const createRequestAction = (): RootActionTypes => ({
  type: ActionTypes.UPDATE_DISPUTE_REQUEST,
});

const createSuccessAction = (payload: io.flow.internal.v0.models.Dispute): RootActionTypes => ({
  type: ActionTypes.UPDATE_DISPUTE_SUCCESS,
  payload,
});

const createFailureAction = (errors: FormattedErrorMessages): RootActionTypes => ({
  type: ActionTypes.UPDATE_DISPUTE_FAILURE,
  payload: errors,
  error: true,
});

export default function updateDispute(
  id: string,
  values: io.flow.internal.v0.models.DisputeOverrideUpdateForm,
): ThunkResult<Promise<void | io.flow.internal.v0.models.Dispute>> {
  return (dispatch, getState, extra): Promise<void | io.flow.internal.v0.models.Dispute> => {
    dispatch(createRequestAction());
    return extra.apiInternal(getState()).disputes.putById({
      id,
      body: values,
    }).then((response) => {
      if (response.ok) {
        dispatch(createSuccessAction(response.body));
        return response.body;
      }

      const errors = formatErrorResponseV2(response);
      dispatch(createFailureAction(errors));
      return undefined;
    });
  };
}
